/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForDevicesByWeekResponseElements
 */
export interface ReportForDevicesByWeekResponseElements {
    /**
     * 
     * @type {Date}
     * @memberof ReportForDevicesByWeekResponseElements
     */
    week: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForDevicesByWeekResponseElements
     */
    count: number | null;
}

export function ReportForDevicesByWeekResponseElementsFromJSON(json: any): ReportForDevicesByWeekResponseElements {
    return ReportForDevicesByWeekResponseElementsFromJSONTyped(json, false);
}

export function ReportForDevicesByWeekResponseElementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDevicesByWeekResponseElements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'week': (json['week'] === null ? null : new Date(json['week'])),
        'count': json['count'],
    };
}

export function ReportForDevicesByWeekResponseElementsToJSON(value?: ReportForDevicesByWeekResponseElements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'week': (value.week === null ? null : value.week.toISOString()),
        'count': value.count,
    };
}

